<template>
 <div>
   <label class="form-label" v-if="showlabel">
     <span>{{ label }}</span>
     <span v-if="required"> *</span>
   </label>
    <div class="row">
      <div class="col">
        <DateGroup v-model="date"
                   :showlabel="true"
                   :label="$t('date')"
                   :required="required"/>
      </div>
      <div class="col col-auto">
        <TimeGroup v-model="time"
                   :showlabel="true"
                   :label="$t('time')"
                   :required="required"/>
      </div>
    </div>
   <ValidationError class="mt-1"
                    v-if="showErrors"
                    :validationId="validationId"/>
 </div>
</template>

<script>

import TimeGroup from "@/components/form/TimeGroup"
import DateGroup from "@/components/form/DateGroup"
import ValidationError from "@/components/form/ValidationError.vue"


export default {
  name: 'DateTimeGroup',
  components: {
    ValidationError,
    TimeGroup,
    DateGroup
  },
  emits: ['input'],
  data() {
    return {
      date: this.value ? this.value.substr(0, 10) : null,
      time: this.value ? this.value.substr(11, 5) : null,
    }
  },
  props: {
    label: {},
    value: {},
    showErrors: {
      type: Boolean,
      default: false
    },
    showlabel: {
      type: Boolean,
      default: true
    },
    calendarIcon: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validationId: {},
    required: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    datetime() {
      return (this.date ? this.date : '0000-00-00')+' '+(this.time ? this.time : '00')+':00'
    },
  },
  mounted() {
  },
  methods: {

  },
  watch: {
    date() {
      this.$emit('input', this.datetime)
    },
    time() {
      this.$emit('input', this.datetime)
    }
  }
}
</script>
